//*******************************************************
import {  Component,
          ChangeDetectorRef,
          Inject,
          ViewChild,
          LOCALE_ID }                   from '@angular/core';

import { Observable, Subscription }     from 'rxjs';

import { formatNumber } from '@angular/common';

// Router
import { Router, ActivatedRoute }       from '@angular/router';
//**************************************************************
// Firestore 
import { firestorecontrol }             from "../../appfirestore/app.firestore";
//*******************************************************
// Field Definitions
import  { 
          collaboratordetail,
          financecategory,
          financecategorylist,
          financecategoryonly,
          costallocation,
          whoseguestinit
        }                                 from '../../appfirestore/app.fields';
//*******************************************************
import {  
          DxFormComponent,
          DxToolbarComponent,
          DxDataGridComponent      
        }                               from 'devextreme-angular';

import notify from 'devextreme/ui/notify';
import hideToasts from 'devextreme/ui/toast/hide_toasts';
//*******************************************************
// Functions
import { appfunctions  }                from '../../functions/app.functions';
// List Structures
import { liststructures }               from '../../classinjection/app.liststructures'
//*******************************************************
@Component(
            {
              selector: 'app-comfinance',
              templateUrl: './comfinance.component.html',
              styleUrls: ['./comfinance.component.scss']
            }
          )
//*******************************************************
export class ComfinanceComponent 
{
  //*******************************************************
  eventid: string = '';
  formheight: number = 0;

  @ViewChild('grideventcollaborator') dataCollaboratorGrid: DxDataGridComponent;
  @ViewChild('formcollaborator') formcollaborator: DxFormComponent;

  // Firestore Paths
  pathcollaborator: string = "/eventcollaborator/collaborator" 

  subscriptioncollaborator: Subscription;
  subscriptioncollaboratorlist: collaboratordetail[];

  subscriptionfinancecategory: Subscription;
  subscriptionfinancecategorylist: financecategory[];

  subscriptioncategory: Subscription;
  subscriptioncategorylist: financecategorylist[];

  // Button
  selButton: number;
  buttondisable: boolean = true;

  // Collaborator Form
  formcollaboratorData: Array<collaboratordetail>
  formcollaboratorDataVarible: any;

  rowCollaboratordata: any;
  rowCollaboratorSelect: boolean = false;
  popupcollaboratorVisible: boolean = false; 
  focusedCollaboratorRowKey: number = 0;
  focusedCollaboratorOldStatus: string;
  focusedCollaboratorGanttid: string;
  focusedCollaboratorCurrActCost: number;
  focusedCollaboratorCurrBudCost: number;
  focusedCollaboratorStatusList: String;
  collabstatusinputvalmsg: string = '';

  popuptitle: string = '';

  statusflag: string = '';
  statusvaluechange: boolean = false;

  collaboratorstatus: Array<string> = [];
  selcollaboratorstatus: string;
  selcategorylist: Array<financecategoryonly> = [];
  selcategory: string;

  textinputvalmsg: string;
  budgetinputvalmsg: string;

  collaboratorid: string = '';
  sharecost: any[] = [];
  collabcost: number = 0;
  collabbudcost: number = 0;

  // Cost Allocation
  whoseguest: Array<whoseguestinit> = []; // Empty Array
  organisercostallocation: Array<costallocation> = [];
  saveorganisercostallocation: Array<string> = [];
  saveorganisercostallocationstring: string = '';
  sharecostparticipant: Array<string> = [];

  iconcollapseexpand = "fa-sharp fa-solid fa-circle-up"

  // Toast Messages
  toastFileMessage: string = '';
  toastVisible: boolean = false;
  toasttypeerror: string = 'error';
  toastdisplaytime: number = 3000;
  toastwidth: string = '240';
  settoastwidth: string = '240';


  labelTemplates: any[]; 
  //*******************************************************
  constructor (
                private _Activatedroute:ActivatedRoute,
                private firestoredata: firestorecontrol, 
                private appfunction: appfunctions,
                private liststruct: liststructures,
                private cdRef: ChangeDetectorRef,
                @Inject(LOCALE_ID) public locale: string
              ) 
    { 


      this.collaboratorcostallocclick = this.collaboratorcostallocclick.bind( this );

      this.saveCollaboratorClick    = this.saveCollaboratorClick.bind(this);
      this.cancelCollaboratorClick  = this.cancelCollaboratorClick.bind( this);

      this.validcollabstatus        = this.validcollabstatus.bind( this );
      this.validbudgetinput         = this.validbudgetinput.bind( this );

      this.newcategory               = this.newcategory.bind( this );

      this.format_categorytotal     = this.format_categorytotal.bind( this );

      this.calculateShareCostSummary = this.calculateShareCostSummary.bind(this);

      this.labelTemplates = 
          [
            { name: 'name',       icon: 'dx-icon-user' },
            { name: 'position',   icon: 'dx-icon-info' },
            { name: 'date',       icon: 'dx-icon-event' },
            { name: 'address',    icon: 'dx-icon-home' },
            { name: 'phone',      icon: 'dx-icon-tel' },
            { name: 'email',      icon: 'dx-icon-email' },
            { name: 'mobile',     icon: 'fa-solid fa-mobile-retro' },
            { name: 'note',       icon: 'fa-regular fa-note-sticky'},
            { name: 'food',       icon: 'fa-solid fa-bowl-food'},
            { name: 'road',       icon: 'fa-sharp fa-solid fa-road'},
            { name: 'letter',     icon: 'fa-solid fa-square-envelope'},
            { name: 'address',    icon: 'fa-solid fa-address-card'}
          ];

    }
  //*******************************************************
  ngOnInit(): void 
    {
      //---------------------------------------------------------------------------------------------
      // EventId
      this.eventid     = String(this._Activatedroute.snapshot.paramMap.get("eventid"))
      // Form Height
      this.formheight  =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));

      //console.log( this.eventid + ' ' +  this.formheight)
      //---------------------------------------------------------------------------------------------
      // Collaborator / Expenditure Details
      this.firestoredata.loadeventcollaborator( this.eventid, 5, '' , []  );
      
      this.subscriptioncollaborator = this.firestoredata.geteventcollaborator().subscribe
        ( items => 
          { 
            this.subscriptioncollaboratorlist = items;
           // console.log( this.subscriptioncollaboratorlist )
          }
        )
      //--------------------------------------------------------------------------------------------
      // Finance Categories Dashboard
      this.firestoredata.loadeventdashboardFinancecategory( this.eventid, ''  );
      
      this.subscriptionfinancecategory = this.firestoredata.geteventdashboardfinancecateory().subscribe
        ( items => 
          { 
            this.subscriptionfinancecategorylist = items;
          }
        )
      //--------------------------------------------------------------------------------------------
      // Finance Category
      this.firestoredata.loadeventFinancecategory( this.eventid  );
      
      this.subscriptioncategory = this.firestoredata.geteventfinancecateory().subscribe
        ( items => 
          { 
            this.subscriptioncategorylist = items;


            // Build initial expense category list;
            
            if (  this.subscriptioncategorylist.length > 0 )
              {
                this.selcategorylist = []

               for (let i = 0; i < this.subscriptioncategorylist.length; i++) 
                  {
                    this.selcategorylist.push( 
                                                {
                                                  category: this.subscriptioncategorylist[i].category
                                                }
                                              ) 

                  }
              
              }

          }
        )
      //--------------------------------------------------------------------------------------------
      // Event Organiser Initials
      this.firestoredata.buildwhoseguestdetails( this.eventid );
      this.whoseguest = this.firestoredata.geteventparticipantdetails();
      //---------------------------------------------------------------------------------------------
      // Collaborator Status
      this.collaboratorstatus = this.liststruct.getcollaboratorstatus();
      //---------------------------------------------------------------------------------------------
      this.dataCollaboratorGrid.instance.expandAll;
      //---------------------------------------------------------------------------------------------
    }
  //*******************************************************
  datagrideditorPreparing( event: any )
    {
      if (  event.rowType == "data"  && event.column.command =="edit" )
        {
        
          var $links = event.cellElement.find(".dx-link");
          // Remove Delete and Edit Icon
          // $links.filter(".dx-link-delete").remove();
          $links.filter(".dx-link-edit").remove();
        }
      }
  //*******************************************************
  onrowCollaboratorclick( event: any )
    { 

      if ( event.rowType == 'data')
        {

            this.rowCollaboratorSelect = true;               // Indicate that Datagrid - Collabprator Row has been selected
            
            this.buttondisable = false;                      // Enable Collaborator form buttons

            this.statusflag   = 'Hide';                      // Hide Allocate Cost Form to force click on Button - Collabotrator Allocate Cost

            this.selcategory                      = event.data.category; 

            // Capture Select Row Data Id
            this.focusedCollaboratorRowKey        = event.data.id;  // Register Data Row - id
            this.focusedCollaboratorOldStatus     = event.data.statuslist;
            this.focusedCollaboratorGanttid       = event.data.ganttId;
            this.focusedCollaboratorCurrActCost   = event.data.amount;
            this.focusedCollaboratorCurrBudCost   = event.data.budget;
            this.focusedCollaboratorStatusList    = event.data.statuslist;
      
            // Store data to Variable
            this.collaboratordataprofile( 10, event )               // Store Data Row Data

        }

    }
  //*******************************************************
  onrowCollaboratorchange( event: any )
    {
      this.buttondisable = true;                               // Enable Collaborator form buttons 
      
      if ( event.row.rowType == 'data')
        {
           
            this.rowCollaboratorSelect = true;                        // Indicate that Datagrid - Collabprator Row has been selected
          
          //  this.buttondisable = false;                               // Enable Collaborator form buttons 

            this.statusflag   = 'Hide';                               // Hide Allocate Cost Form to force click on Button - Collabotrator Allocate Cost

            this.selcategory                      = event.row.data.category; 
          
            // Capture Select Row Data Id
            this.focusedCollaboratorRowKey        = event.row.data.id;          // Register Data Row - id
          
            this.focusedCollaboratorOldStatus     = event.row.data.statuslist;
            this.focusedCollaboratorGanttid       = event.row.data.ganttId;

            this.focusedCollaboratorCurrActCost   = event.row.data.amount;
            this.focusedCollaboratorCurrBudCost   = event.row.data.budget;
          
            // Save data
            this.collaboratordataprofile( 20, event )                    // Store Data Row Data
        }

    }
  //*******************************************************
  collaboratordataprofile( settype: number,  seldata: any)
    {
      switch ( settype )
        {
          // Row Click
          case 10:
            {
              this.formcollaboratorData      = seldata.data;
              this.rowCollaboratordata       = seldata.data;   // Collaborator Data before any edit changes
              break;
            }

          // Row Change
          case 20:
            {
              this.formcollaboratorData      = seldata.row.data;
              this.rowCollaboratordata       = seldata.row.data;  // Collaborator Data before any edit changes
              break;
            }

        }

    }
//*******************************************************
onCellHoverCollaborator( event: any )
  {

  }
//*******************************************************
collaboratorcostallocclick( event: any)
  {

    this.collaboratorid   = event.row.data.id;
    this.sharecost        = event.row.data.sharecost; // Current Profile of Sharecost - Array
    this.collabcost       = event.row.data.amount;    
    this.collabbudcost    = event.row.data.budget;    

  //  console.log(  this.collaboratorid );
  //  console.log(  this.sharecost )
  //  console.log( this.collabbudcost  + '-' + this.collabcost )

    // Build Sharecost Profile 
    this.buildShareCostList(  this.sharecost, this.collabcost, this.collabbudcost  )

    this.statusflag = event.row.data.statuslist;
  }
//*******************************************************
buildShareCostList( sellist: any, selcost: number, selbudcost: number  )
  {
    var organisercostprofile: string;
    var allocationperc: number;

    this.organisercostallocation = [];
    //---------------------------------------------------------------------------------------------
    // Validate whether there is any prior participant cost allocation
    if ( sellist.length > 0 )
      {
          //---------------------------------------------------------------------------------------------
          for ( let i = 0; i <= sellist.length-1; i++ )
            { 
              organisercostprofile = sellist[i];  // Collaborator Profile
             
              const splitstr = organisercostprofile.split("#");
              allocationperc = +splitstr[1]

              this.organisercostallocation.push( {
                                                    id: splitstr[0],                    // Collaborator Id
                                                    percallocation: allocationperc,     // % Share Costs
                                                    confirmcost: selcost,               // Actual Cost 
                                                    confirmbudget: selbudcost,          // Budget Cost
                                                    status: ''                                 
                                                  }
                                                );
            }
          //---------------------------------------------------------------------------------------------
          // Determine any new event organisers to update list
          if ( this.whoseguest.length != sellist.length )
            {
              // Update Array
              for ( let i = 0; i <= this.whoseguest.length-1; i++ )
                {
                  let selorgid      = this.whoseguest[i].id;
                  let findselorgid  = this.organisercostallocation.find( p => p.id == selorgid )

                  if ( findselorgid == undefined ) // New Event Participant
                    {

                      this.organisercostallocation.push( {
                                                            id: selorgid,
                                                            percallocation: 0,
                                                            confirmcost: selcost,       
                                                            confirmbudget: selbudcost,  
                                                            status: ''                                 
                                                          }
                                                        );
                    }

                }

            }
          //---------------------------------------------------------------------------------------------  
          // This is triggered by clicking on button - to allocate cost amongst event organiser(s)
          // Update Firestore Collection - Collaborator -> flds sharecost [ array ] + sharecoststring
          // If allocations and/or actual amount current differs from previous Cloudstore Function will recalculate
          this.updateShareCost( null);
          //---------------------------------------------------------------------------------------------
      }
    else
      {
        // New Organiser Build Profile
        for ( let i = 0; i <= this.whoseguest.length-1; i++ )
          { 
            
              this.organisercostallocation.push( {
                                                    id: this.whoseguest[i].id,
                                                    percallocation: 0,
                                                    confirmcost: selcost,       
                                                    confirmbudget: selbudcost,  
                                                    status: ''                                 
                                                  }
                                                  
                                                );
          }

        // This is triggered by clicking on button - to allocate cost amongst event organiser(s)
        // Update Firestore Collection - Collaborator -> flds sharecost [ array ] + sharecoststring
        //
        // There should be 0 +/- cost changes from previous to current

        this.updateShareCost( null)
      }
    //---------------------------------------------------------------------------------------------


  }
//*******************************************************
updateShareCost( event: any )
  {
    
    // Updating Collaborator - suppliers with event participants share cost details
    // A firestore - trigger will allocate the cost for participants and total
    
    this.buildloadShareCostList( this.organisercostallocation )

    if (  this.saveorganisercostallocation.length > 0 )
      {
        
        console.log( this.saveorganisercostallocation )

        this.firestoredata.commitbatchupdate( 
                                              this.pathcollaborator, 
                                              this.eventid,
                                              this.collaboratorid,
                                              'sharecost',      
                                              this.saveorganisercostallocation  // Collaborator Profile - Array
                                            );  

        this.firestoredata.commitbatchupdate( 
                                                this.pathcollaborator, 
                                                this.eventid,
                                                this.collaboratorid,
                                                'sharecoststring', 
                                                this.saveorganisercostallocationstring // Collaborator Profile - String
                                              );
                                              
        this.firestoredata.commitbatchupdate( 
                                                this.pathcollaborator, 
                                                this.eventid,
                                                this.collaboratorid,
                                                'sharecostparticipant',  
                                                this.sharecostparticipant // Collaborator(s) with % Share - Array
                                              );

      //---------------------------------------------------------------------------------------------
      this.buttondisable = true;                      // Disable Collaborator form buttons
      this.statusflag   = 'Hide';    
      //---------------------------------------------------------------------------------------------

      }
 
  }
//*******************************************************
buildloadShareCostList( sellist: any  )
    {
      var savecostprofile: string;
      var savecostprofilestring: string;

      var allocationperc: number;
      var organisersharestatus: string;

      this.saveorganisercostallocation = [];
      this.sharecostparticipant        = [];
      this.saveorganisercostallocationstring = '';

      if ( sellist.length > 0 )
        {

          for ( let i = 0; i <= sellist.length-1; i++ )
            { 
              //---------------------------------------------------------------------------------------------
              allocationperc        = sellist[i].percallocation
              organisersharestatus  = sellist[i].id + 'O'   // O indicates no % allocation has been set for collaborator

              if ( allocationperc > 0 )  
                {
                  organisersharestatus  = sellist[i].id + 'X' // X indicates  % allocation has been set for collaborator

                  // Identify EventOrganiser that has contributed to the cost of the event
                  this.sharecostparticipant.push( sellist[i].id )
                }
              //---------------------------------------------------------------------------------------------  
              savecostprofile                         = sellist[i].id             + '#' + 
                                                        sellist[i].percallocation + '#' + 
                                                        sellist[i].confirmcost    + '#' +
                                                        sellist[i].confirmbudget  + '#' +
                                                        organisersharestatus;
              // Array
              this.saveorganisercostallocation.push ( 
                                                      savecostprofile
                                                    );
              //---------------------------------------------------------------------------------------------
              // String
              savecostprofilestring                   = sellist[i].id             + '#' + 
                                                        sellist[i].percallocation + '#' + 
                                                        sellist[i].confirmcost    + '#' +                
                                                        sellist[i].confirmbudget;

              this.saveorganisercostallocationstring  = this.saveorganisercostallocationstring + savecostprofilestring + ',';
              //---------------------------------------------------------------------------------------------
            }

            this.saveorganisercostallocationstring  = this.saveorganisercostallocationstring.substring(0, this.saveorganisercostallocationstring.length - 1)
           
        }

    }
//*******************************************************
collaboratorform( event: any, seloption: number)
  {
    var status: boolean
    //---------------------------------------------------------------------------------------------
    this.selButton          = seloption;    // Which Button Add=10 or Edit=20 
    this.statusvaluechange  = false;        // Detect any changes it formdata fields
    this.statusflag         = 'Hide';
    //---------------------------------------------------------------------------------------------
    // Determine whether a ROW is selected when its not a ADD option
    if ( this.selButton  != 10 )
      {
        
        if ( this.rowCollaboratorSelect ) 
          {
            status             = true;
          }
        else
          {
            status             = false; 
          }
     }
    //---------------------------------------------------------------------------------------------
    switch ( seloption )
      {
        //---------------------------------------------------------------------------------------------
        // Add Collaborator
        case 10:
            {
              this.formcollaborator.instance.repaint();
              //---------------------------------------------------------------------------------------------
              // Set Inputs to default values
              this.formcollaboratorData                         = [];
              this.formcollaboratorDataVarible                  = [];

              let collaboratid                                  = this.appfunction.createuniqueid(6) 
              this.selcategory                                  = ''
              //---------------------------------------------------------------------------------------------
              // Assign Values
              this.formcollaboratorDataVarible                  = this.formcollaboratorData;

              this.selcollaboratorstatus                        = 'Listed'  // Default Value

              this.formcollaboratorDataVarible.id               = collaboratid;
              this.formcollaboratorDataVarible.statuslist       = this.selcollaboratorstatus;

              this.formcollaboratorDataVarible.amount           = 0;
              this.formcollaboratorDataVarible.budget           = 0;

              this.formcollaboratorDataVarible.category         = this.selcategory

              this.formcollaboratorDataVarible.providername     = 'TBC';
              this.formcollaboratorDataVarible.contactperson    = '';
              this.formcollaboratorDataVarible.mobile           = '';
              this.formcollaboratorDataVarible.phone            = '';
              this.formcollaboratorDataVarible.email            = '';
              this.formcollaboratorDataVarible.notes            = '';
              this.formcollaboratorDataVarible.street           = '';
              this.formcollaboratorDataVarible.suburb           = '';
              this.formcollaboratorDataVarible.state            = '';
              this.formcollaboratorDataVarible.postcode         = '';

              this.formcollaboratorDataVarible.ganttId          = '';
              this.formcollaboratorDataVarible.parenttaskid     = '';
              //---------------------------------------------------------------------------------------------
              // Set Default Value to Collaborator FormData 
              this.formcollaboratorData = this.formcollaboratorDataVarible;

            // console.log( this.formcollaboratorData  )
              //---------------------------------------------------------------------------------------------
              this.popuptitle                 = 'Add Collaborator';
              this.popupcollaboratorVisible   = true;
              this.buttondisable              = true;

              break;  
            }
        //---------------------------------------------------------------------------------------------
        // Edit Collaborator
        case 20:
          {
            if ( status )
              {
                  this.formcollaborator.instance.repaint();
                  this.popuptitle                                   = 'Edit Collaborator';
                 // this.formcollaboratorDataVarible.category         = this.selcategory
                  this.popupcollaboratorVisible                     = true;
              }

            break;  
          }
        //---------------------------------------------------------------------------------------------
      }
      //---------------------------------------------------------------------------------------------
  }
  //*******************************************************
  // Save Collaborator Detail 
  saveCollaboratorClick( event: any )
    {

      //console.log( this.selcategory)
    
      let validresult = this.formcollaborator.instance.validate();
   
      if ( validresult.isValid )
        {
          this.formcollaboratorDataVarible =  this.formcollaboratorData;

          // Update Firestore
          this.firestoredata.addUpdateCollaborator( this.selButton, this.eventid, this.formcollaboratorDataVarible, 0 );

          // Focus Row when Saved
          //  this.dataCollaboratorGrid.instance.clearSelection();
          //  this.dataCollaboratorGrid.instance.option("focusedRowKey",  -1 );
          //  setTimeout(() => {
          //                      this.dataCollaboratorGrid.instance.option("focusedRowKey",  this.focusedCollaboratorRowKey  );
          //                    }, 100
          //            );

           //   this.dataCollaboratorGrid.instance.focus();

          this.rowCollaboratorSelect    = false;               // Indicate that Datagrid - Collabprator Row has been selected
          this.buttondisable            = true;     
          this.popupcollaboratorVisible = false;
          //---------------------------------------------------------------------------------------------
          if ( this.selButton == 20 ) // Edit Button
            {                
              // Collaborator statuslist has changed Confirm <> Listed OR Confirm <> Shortlist
              // Cost Allocation has to recalculate to 0
              if ( this.focusedCollaboratorStatusList == 'Confirm' )
                {

                  //  console.log( this.focusedCollaboratorStatusList )
                  //  console.log( this.formcollaboratorDataVarible.statuslist )

                  if ( this.focusedCollaboratorStatusList != this.formcollaboratorDataVarible.statuslist ) 
                    {

                      //this.displayToast( 'Confirm Status has been reset. Allocation Cost will set back 0.', 'error', 5000, '300' )
                      
                      this.display_notify(  'Confirm Status has been reset. Allocation Cost will set back 0.',
                                            "warning",
                                            5000,
                                            'top left',
                                            45,
                                            300,
                                            300
                                          );


                      // This will Trigger Firestore - function -> collaborator_function
                      this.firestoredata.addUpdateCollaborator( 30, this.eventid, this.formcollaboratorDataVarible, 0 );

                    }
                
                  //---------------------------------------------------------------------------------------------
                  // Actual Amount Changes <> Previous Opening Amount = Hide the Cost Allocation Screen
                  // This will force the User to click Cost Allocation which will refesh Cost Allocation Array

                //  console.log(  this.focusedCollaboratorStatusList + '#' + this.formcollaboratorDataVarible.statuslist )
                 console.log( this.focusedCollaboratorCurrActCost + '#' + this.formcollaboratorDataVarible.amount )
                 console.log( this.focusedCollaboratorCurrBudCost + '#' + this.formcollaboratorDataVarible.budget  )

                  if   ( this.focusedCollaboratorStatusList == this.formcollaboratorDataVarible.statuslist && this.focusedCollaboratorCurrActCost != this.formcollaboratorDataVarible.amount  || 
                        this.focusedCollaboratorStatusList == this.formcollaboratorDataVarible.statuslist && this.focusedCollaboratorCurrBudCost != this.formcollaboratorDataVarible.budget    ) 
                    
                    {

                   //   console.log( this.formcollaboratorDataVarible )
                  //    console.log( this.formcollaboratorDataVarible.amount )
                    //  console.log(  this.formcollaboratorDataVarible.budget )

                      this.display_notify (  'Actual and/or Budget Amounts have changed. There will be a recalculation',
                                            "warning",
                                            5000,
                                            'top left',
                                            45,
                                            550,
                                            550
                                        );

                      this.buildShareCostList( this.formcollaboratorDataVarible.sharecost, this.formcollaboratorDataVarible.amount, this.formcollaboratorDataVarible.budget)

                      this.statusflag = 'Hide';
                    
                     // this.displayToast( 'Actual and/or Budget Amounts have changed. You will need to recalculate cost allocation by clicking on Button - Calculator Button.', 'error', 5000, '300' )

                    }

                }
              //---------------------------------------------------------------------------------------------
            }
        }
     
    }
  //*******************************************************
  cancelCollaboratorClick()
    { 

      if ( this.statusvaluechange ) // If there is any changes but cancel update with previous data by trigger refresh
        {
          //---------------------------------------------------------------------------------------------
          // Edit Mode
          if ( this.selButton == 20 )
            {
              // Update Firestore to Trigger Refresh with previous values
              this.firestoredata.commitbatchupdate( 
                                                    this.pathcollaborator, 
                                                    this.eventid,
                                                    this.focusedCollaboratorRowKey.toString(),
                                                    'triggerrefresh', 
                                                    this.appfunction.createuniqueid(3)
                                                  );  

              // Focus Row when cancel
              this.dataCollaboratorGrid.instance.clearSelection();
              this.dataCollaboratorGrid.instance.option("focusedRowKey",  -1 );
              setTimeout(() => {
                                  this.dataCollaboratorGrid.instance.option("focusedRowKey",  this.focusedCollaboratorRowKey  );
                                }, 100
                        );

              this.dataCollaboratorGrid.instance.focus();

              
            }
          //--------------------------------------------------------------------------------------------- 
        }
      //---------------------------------------------------------------------------------------------
      this.rowCollaboratorSelect      = false;   
      this.buttondisable              = true;
      this.popupcollaboratorVisible   = false;
      
    }
  //*******************************************************
  formCollaboratorDatafldchange( event: any )
    {
      // Formdata has changed
      this.statusvaluechange = true;
    }
  //******************************************************* 
  validcollabstatus(e): boolean
    {
      var statusinput: string

      statusinput = e.value;

      if ( statusinput.length > 0 )
        {
          return true  
        }
      else
        {
          this.textinputvalmsg = "Input cannot be blank"
          return false;
        }
    
    }
  //*******************************************************
  validbudgetinput(e): boolean
    {
      var budgetinput: any

      budgetinput = e.value;

      if ( budgetinput != null )
        {

          if ( budgetinput >= 0 )
            {
              return true
            }
          else
            {
              this.budgetinputvalmsg = "Budget Number cannot < 0"
              return false
            }

        }
      else
        {
          this.budgetinputvalmsg = "Budget Number is required"
          return false 
        }
     
    }
  //******************************************************* 
  newcategory( e: any )
    { 
      const newItem = e.text;

    console.log( newItem )

    let findcategory  = this.selcategorylist.find( p => p.category == e.text );

    if ( findcategory == undefined )
      {
        this.selcategory =  e.text;

        this.selcategorylist.push(  
                                    {
                                        category: e.text
                                    }
                                  )

        this.formcollaborator.instance.repaint();
      }
    
    }
  //*******************************************************
  onRowPrepared( event: any )
    {
      var i: number;

      if ( event.rowType == 'group' )
        {
          event.rowElement.css("backgroundColor", "#b0e0e6");
          event.rowElement.css("color", "black");
        }
      
    }
  //*******************************************************
  onCellPrepared( event: any )
    {
      var i: number;


      if ( event.rowType == 'data'  )
        {
          event.cellElement.css("color", "black");
          
        //  if ( event.column.dataField == 'providername'  )
          if ( event.columnIndex <= 5  )
            {

              event.cellElement.css("backgroundColor", "#77849C");

              if ( event.data.statuslist == 'Confirm' )
                {
                
                  if ( event.data.sharecostparticipant.length == 0 ) 
                    {
                      event.cellElement.css("backgroundColor", "#93C47D");
                    }
                  else
                    {
                      event.cellElement.css("backgroundColor", "#4BA0F0");
                    }

                }

            }
        }
      
    }
  //*******************************************************
  groupshowcollapse( event: any )
    {

      var Cancollapse: boolean = false;

      const visibleRows = this.dataCollaboratorGrid.instance.getVisibleRows();

      for ( let i = 0; i <= visibleRows.length-1; i++ )
        {
            if ( visibleRows[i].rowType == 'group' )
              {
                if ( visibleRows[i].isExpanded )
                  {
                    Cancollapse = true;
                    break;
                  }

              }
        }

      if ( Cancollapse) 
        {
          this.dataCollaboratorGrid.instance.collapseAll();
          this.iconcollapseexpand = 'fa-sharp fa-solid fa-circle-down';
          //console.log("Group rows can be collapsed.");
        } 
      else 
        {
          this.dataCollaboratorGrid.instance.expandAll();
          this.iconcollapseexpand = 'fa-sharp fa-solid fa-circle-up';
          //console.log("Group rows can be expanded");
        }

    }
  //*******************************************************
  format_categorytotal ( cellInfo  )
    {
     
      var x: string = cellInfo.value.toString();
   
      return 'Total:' + this.format_number( x )  + formatNumber(Number(x.trim()), 'en-US', '1.2-2' ) ;
    }
  //*******************************************************
  format_number( whatvalue: string)  
    {
      var numlen: number;
      var NoSpace: number;
      var aspace: string = '';

      numlen = whatvalue.length 
      NoSpace = 12 - numlen;

      switch ( numlen )
      {

        case 1:
          {
            NoSpace = NoSpace + 5;
            break;
          }

        case 2:
          {
            NoSpace = NoSpace + 4;
            break;
          }

        case 3:
          {
            NoSpace = NoSpace + 3;
            break;
          }

        case 4:
          {
            NoSpace = NoSpace + 1;
            break;
          }

        case 5:
          {
            NoSpace = NoSpace - 0;
            break;
          }

        case 6:
          {
            NoSpace = NoSpace - 2;
            break;
          }

        case 7:
          {
            NoSpace = NoSpace - 3;
            break;
          }

        case 8:
          {
          //  NoSpace = NoSpace - 5;
            break;
          }

        case 9:
          {
          //  NoSpace = NoSpace - 6;
            break;
          }

        case 10:
          {
          //  NoSpace = NoSpace - 7;
            break;
          }

        case 11:
          {
           // NoSpace = NoSpace - 8;
            break;
          }

        case 12:
          {
          //  NoSpace = NoSpace - 9;
            break;
          }
      }

      for ( let i = 0; i < NoSpace; i++) 
        {
          aspace = aspace + '\xa0';
        }
   
      return aspace

    }
  //*******************************************************
  calculateShareCostSummary(options) 
    {
      if (options.name === "ShareCostSummary") 
      {

          if (options.summaryProcess === "start") 
            {
                options.totalValue = 0;
            }

          if (options.summaryProcess === "calculate") 
            {
            // console.log( options.value )
              options.totalValue += this.ShareCost(options.value)  
            // options.totalValue += options.value.confirmcost * ( options.value.percallocation / 100 ) ;
            }

          if (options.summaryProcess === "finalize") 
            {
              //console.log( options.totalValue)
            }
      }
    }
  //*******************************************************
  ShareCost( rowData: any )
    {
      return  rowData.confirmcost * ( rowData.percallocation / 100 ) 
    }
  //*******************************************************
  SetShareCost( newData, value, currentRowData )
    {
      newData.percallocation = value;
      newData.calcsharecost =  ( value / 100 ) * currentRowData.confirmcost;
    }
  //*******************************************************
  displayToast( toastmsg: string, toaststatus: string, toastdisplaysec: number, toastwidth: string )
    {

      this.toastFileMessage = toastmsg;
      this.toasttypeerror   = toaststatus;
      this.toastdisplaytime = toastdisplaysec;
      this.toastwidth       = toastwidth ;
      this.toastVisible     = true;

    }
  
  //*******************************************************
  display_notify( msg: string, msgtype: string, msgdisplaysec: number, notifyposition: string,
                  msgheight: number, msgwidth: number, msgminwidth: number )
    {

      const position: any = notifyposition

      notify(
              {
                message: msg,

                type: msgtype,

                height: msgheight,
                width: msgwidth,
                minWidth: msgminwidth,

                displayTime: msgdisplaysec,

                animation: {
                            show: {
                                    type: 'fade', duration: 400, from: 0, to: 1,
                                  },
                            hide: { 
                                    type: 'fade', duration: 40, to: 0 },
                            }

              },
              { 
                position
              }

            )
    }
  //*******************************************************
  //---------------------------------------------------------------------------------------------
  changcategory( e: any )
    {
      //console.log( e)
      this.selcategory =  e.value;
    }

}
